module.exports = __webpack_public_path__ + "img/media_reg_2.4ab45aea.png";